import React from 'react';

// Styles & Assets
import styles from './QuestionPoll.module.css';
import { RiPencilFill } from 'react-icons/ri';
import { ReactComponent as BinSVG } from '../../../assets/icons/bin.svg';

// Services
import { sortByAttribute } from '../../../services/sort';

// Hooks
import { useState } from 'react';

// Components
import AddQuestionDialog from './../AddQuestionDialog/AddQuestionDialog';
import Modal from '../../UI/Modal/Modal';

// Interfaces
import { PollQuestion } from '../../../interfaces/Poll';
import ButtonQuestionPoll from '../ButtonQuestionPoll/ButtonQuestionPoll';

const QuestionPoll: React.FC<{
    question: PollQuestion,
    hasTable: boolean
    deleteQuestion: () => void,
    editQuestion: (question: PollQuestion) => void,
    children: React.ReactElement,
}> = ({ question, hasTable, deleteQuestion, editQuestion, children }) => {

    const [showAddQuestionDialog, setShowQuestionDialog] = useState<boolean>(false);

    return (
        <>
            <div className={styles.questionContainer}>
                <ButtonQuestionPoll onClick={deleteQuestion}>
                    <BinSVG className={styles.icon} />
                </ButtonQuestionPoll>
                <ButtonQuestionPoll onClick={() => setShowQuestionDialog(true)}>
                    <RiPencilFill className={styles.icon} />
                </ButtonQuestionPoll>
                {children}
                <div className={styles.questionInfo}>
                    <p className={styles.questionDescription}>{question.order !== undefined ? question.order + 1 : ''} - {question.description} {question.required ? '*' : ''}</p>
                    <div className={styles.answersContainer}>
                        {question && question.inquiry_question_type_id === 1 && question.answers &&
                            sortByAttribute(question.answers, 'order').map((answer, indexQ) =>
                                <p className={styles.answer} key={answer.uuid || answer.id}>
                                    {indexQ + 1} - {answer.description} {answer.value !== null && answer.value !== undefined ? '(' + answer.value + ')' : ''}
                                </p>)
                        }
                    </div>
                </div>
            </div>
            <Modal show={showAddQuestionDialog} setShowModal={setShowQuestionDialog}>
                <AddQuestionDialog
                    addQuestion={(question: PollQuestion) => editQuestion(question)}
                    setShowQuestionDialog={setShowQuestionDialog}
                    defaultQuestion={question}
                    hasTable={hasTable}
                />
            </Modal>
        </>
    );
};

export default QuestionPoll;